import React from 'react';
import isAfter from '../utils/is.after';

const stepStyle = (progressBarStep, appStateStep) =>
  isAfter(progressBarStep, appStateStep) ? 'pending' : 'visited';

const ProgressCLBar = ({ step, messages }) => (
  <aside className="progressbar ProgressCLBar">
    <ol>
      <li className={stepStyle('miniApp', step)}>
        <span className="firststep">1</span> <span className="landing-page-display">Personalize</span>
      </li>
      <li className={stepStyle('quotes', step)}>
        <span className="firststep">2</span> <span className="landing-page-display">Bank details</span>
      </li>
      <li className={stepStyle('fullApp', step)}>
        <span className="firststep">3</span> <span className="landing-page-display">Confirm</span>
      </li>
    </ol>
  </aside>
);

export default ProgressCLBar;
